module.exports = __webpack_public_path__ + "img/13.a4ebca57.png";